import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollRestorationManager() {
  const location = useLocation();
  const navType = useNavigationType(); 
  const positionsRef = useRef<Map<string, number>>(new Map());
  const lastKeyRef = useRef<string | null>(null);

 
  useEffect(() => {
    const prev = (window.history as any).scrollRestoration;
    try { (window.history as any).scrollRestoration = "manual"; } catch {}
    return () => { try { (window.history as any).scrollRestoration = prev ?? "auto"; } catch {} };
  }, []);


  useEffect(() => {
    const onBeforeUnload = () => {
      if (lastKeyRef.current) {
        positionsRef.current.set(lastKeyRef.current, window.scrollY || 0);
      }
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, []);


  useEffect(() => {
    if (lastKeyRef.current) {
      positionsRef.current.set(lastKeyRef.current, window.scrollY || 0);
    }
    const key =
      (location as any).key ??
      `${location.pathname}${location.search}${location.hash}`;
    lastKeyRef.current = key;
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    const key =
      (location as any).key ??
      `${location.pathname}${location.search}${location.hash}`;

    const getHeaderOffset = () => {
      const root = document.documentElement;
      const v = getComputedStyle(root).getPropertyValue("--navbar-h")?.trim();
      if (v?.endsWith("px")) return parseFloat(v) || 0;
      if (v) {
        const probe = document.createElement("div");
        Object.assign(probe.style, { position: "absolute", visibility: "hidden", height: v });
        document.body.appendChild(probe);
        const h = probe.getBoundingClientRect().height;
        probe.remove();
        return h || 0;
      }
      return 80;
    };
    const HEADER_OFFSET = getHeaderOffset();

    const scrollToTopHard = () => {

      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
 
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
   
        setTimeout(() => {
          if (window.scrollY !== 0) {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
          }
        }, 120);
      });
    };

    const scrollToAnchor = (hash: string) => {
      const id = decodeURIComponent(hash.replace(/^#/, ""));
      let tries = 0;
      const maxTries = 24; 
      const tick = () => {
        const el = document.getElementById(id) || document.querySelector(`[name="${id}"]`);
        if (el) {
          const rect = (el as HTMLElement).getBoundingClientRect();
        
          if (rect.height === 0 && tries++ < maxTries) {
            return requestAnimationFrame(tick);
          }
          const y = rect.top + window.scrollY - HEADER_OFFSET - 8;
          window.scrollTo({ top: Math.max(0, y), behavior: "auto" });
          return;
        }
        if (tries++ < maxTries) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    const keepScroll = (location.state as any)?.keepScroll === true;

    if (location.hash) {
      scrollToAnchor(location.hash);
      return;
    }

    if (navType === "POP") {
      const y = positionsRef.current.get(key) ?? 0;
      const restore = () => window.scrollTo({ top: y, left: 0, behavior: "auto" });
      restore();
      requestAnimationFrame(restore);
      setTimeout(() => {
        if (Math.abs((window.scrollY || 0) - y) > 1) restore();
      }, 120);
      return;
    }

    if (!keepScroll) {
      scrollToTopHard();
    }
  }, [location, navType]);

  return null;
}
